import { graphCNCConfig } from "./cncGraphs";
import { graphExtrusionFormConfig } from "./extrusionGraphs";
import { graphFormConfig } from "./injectionMouldingGraphs";
import { graphPressPunchFormConfig } from "./pressPunchGraphs";

const templateConfig = (templateId) => {
  switch (templateId) {
    case 1:
      return graphFormConfig;
    case 2:
      return graphExtrusionFormConfig;
    case 3:
      return graphPressPunchFormConfig;
    case 4:
      return graphCNCConfig;
  }
};
export default templateConfig;
